import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import { Product } from '@/shared/types/productTypes';
import { PaginatedResponse } from '@/shared/types/responseTypes';

// Use Account Products Query
export const useAccountProducts = (enabled: boolean, pageIndex: number) => {
  return useQuery({
    queryKey: ['products', pageIndex],
    queryFn: async () => {
      const response = await apiClient.get<PaginatedResponse<Product>>(
        `/api/v1/products`,
        { params: { 'page': pageIndex } }
      );
      return response.data;
    },
    enabled: enabled,
  });
};

/** Infinite scroll fetch for products load-more. */
export const useInfiniteAccountProducts = () => {
  return useInfiniteQuery({
    queryKey: ['products'],
    queryFn: async ({ pageParam }: { pageParam: number }) => {
      const response = await apiClient.get<PaginatedResponse<Product>>(
        `/api/v1/products`,
        { params: { page: pageParam } }
      );
      return response.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.isLastPage ? undefined : lastPageParam + 1,
  });
};
